import Vue from 'vue'
import { findIndex } from 'lodash'

const mutations = {
  signIn (state, payload) {
    state.user = {
      isAuthenticated: true,
      token: payload.token,
      name: payload.userName,
      expiresIn: payload.expiresIn,
      isAdmin: payload.isAdmin
    }
  },
  signInError (state, status) {
    state.user = {
      status: status,
      isAuthenticated: false
    }
  },

  setVersionInfo (state, payload) {
    state.versions = payload
  },

  setStaticText (state, payload) {
    state.staticTexts[payload.textKey] = payload.text
  },

  setStorageLatestUpdateTime (state, payload) {
    state.storageUpdateDate = payload
  },

  setCrushingDrugForms (state, payload) {
    state.crushingDrugForms = payload
  },

  setEyedropDosages (state, payload) {
    state.eyedropDosages = payload
  },

  setEyedropGeneralRecommendation (state, payload) {
    state.eyedropGeneralRecommendation = payload
  },

  setGeneralRecText (state, payload) {
    state.generalRecText = payload
  },

  setPdf (state, payload) {
    state.pdf = payload
  },

  setApplicationDynamicText (state, payload) {
    state.applicationDynamicTexts[payload.recordKey] = payload.textObj
  },

  get (state, payload) {
    state[payload.property] = payload[payload.property]
  },

  updateDilution (state, dilution) {
    let index = findIndex(state.dilutions, (item) => { return item.id === dilution.id })
    Vue.set(state.dilutions, index, dilution)
  },

  deleteDilution (state, dilution) {
    let index = findIndex(state.dilutions, (item) => { return item.id === dilution.id })
    if (index !== -1) {
      state.dilutions.splice(index, 1)
    }
  },

  createDilution (state, dilution) {
    state.dilutions.push(dilution)
  },

  updateSubstitution (state, substitution) {
    let index = findIndex(state.substitutions, (item) => { return item.id === substitution.id })
    Vue.set(state.substitutions, index, substitution)
  },

  deleteSubstitution (state, substitution) {
    let index = findIndex(state.substitutions, (item) => { return item.id === substitution.id })
    if (index !== -1) {
      state.substitutions.splice(index, 1)
    }
  },

  createSubstitution (state, substitution) {
    state.substitutions.push(substitution)
  },

  updateNote (state, note) {
    let index = findIndex(state.notes, (item) => { return item.id === note.id })
    Vue.set(state.notes, index, note)
  },

  deleteNote (state, note) {
    let index = findIndex(state.notes, (item) => { return item.id === note.id })
    if (index !== -1) {
      state.notes.splice(index, 1)
    }
  },

  createNote (state, note) {
    state.notes.push(note)
  },

  updateReference (state, reference) {
    let index = findIndex(state.references, (item) => { return item.id === reference.id })
    Vue.set(state.references, index, reference)
  },

  deleteReference (state, reference) {
    let index = findIndex(state.references, (item) => { return item.id === reference.id })
    if (index !== -1) {
      state.references.splice(index, 1)
    }
  },

  createReference (state, reference) {
    state.references.push(reference)
  },

  updateContent (state, content) {
    let index = findIndex(state.contents, (item) => { return item.id === content.id })
    Vue.set(state.contents, index, content)
  },

  createReducedKidneyFunctionDrug (state, drug) {
    state.reducedKidneyFunctionDrugs.push(drug)
  },

  updateReducedKidneyFunctionDrug (state, drug) {
    let index = findIndex(state.reducedKidneyFunctionDrugs, (item) => { return item.id === drug.id })
    Vue.set(state.reducedKidneyFunctionDrugs, index, drug)
  },

  deleteReducedKidneyFunctionDrug (state, drug) {
    let index = findIndex(state.reducedKidneyFunctionDrugs, (item) => { return item.id === drug.id })
    if (index !== -1) {
      state.reducedKidneyFunctionDrugs.splice(index, 1)
    }
  }

}

export default mutations
